module.exports = __webpack_public_path__ + "static/media/audit.d4d7b590.svg";